import { render, staticRenderFns } from "./AdsPlacesTable.vue?vue&type=template&id=f00e4148"
import script from "./AdsPlacesTable.vue?vue&type=script&lang=js"
export * from "./AdsPlacesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports